import { supabase } from '@/integrations/supabase/client';

export interface PatternUpdate {
  id: string;
  bot_id: string;
  pattern: string;
  old_frequency: number;
  new_frequency: number;
  old_success_rate: number;
  new_success_rate: number;
  trade_result: number;
  sequence_used: string;
  created_at: string;
}

export const PatternUpdateService = {
  /**
   * Get recent pattern updates for a specific bot
   */
  async getPatternUpdatesForBot(botId: string, limit = 10): Promise<PatternUpdate[]> {
    try {
      const { data, error } = await supabase
        .from('pattern_incremental_updates')
        .select('*')
        .eq('bot_id', botId)
        .order('created_at', { ascending: false })
        .limit(limit);

      if (error) throw error;
      return data || [];
    } catch (error) {
      console.error('Error fetching pattern updates:', error);
      return [];
    }
  },

  /**
   * Get recent pattern updates for all bots
   */
  async getAllPatternUpdates(limit = 50): Promise<PatternUpdate[]> {
    try {
      const { data, error } = await supabase
        .from('pattern_incremental_updates')
        .select('*')
        .order('created_at', { ascending: false })
        .limit(limit);

      if (error) throw error;
      return data || [];
    } catch (error) {
      console.error('Error fetching all pattern updates:', error);
      return [];
    }
  },

  /**
   * Subscribe to real-time pattern updates for a specific bot
   */
  subscribeToPatternUpdates(
    botId: string, 
    callback: (update: PatternUpdate) => void
  ) {
    return supabase
      .channel(`pattern-updates-${botId}`)
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'pattern_incremental_updates',
          filter: `bot_id=eq.${botId}`
        },
        (payload) => {
          if (payload.new) {
            callback(payload.new as PatternUpdate);
          }
        }
      )
      .subscribe();
  },

  /**
   * Delete all pattern updates for a specific bot
   */
  async deletePatternUpdatesForBot(botId: string): Promise<void> {
    try {
      const { error } = await supabase
        .from('pattern_incremental_updates')
        .delete()
        .eq('bot_id', botId);

      if (error) throw error;
      console.log(`✅ Deleted all pattern updates for bot ${botId}`);
    } catch (error) {
      console.error('Error deleting pattern updates:', error);
      throw error;
    }
  }
};